import game1 from "./assets/product-01.jpg";
import games1 from "./assets/product-02.jpg";
import game2 from "./assets/product-03.jpg";
import games2 from "./assets/product-04.jpg";
import game3 from "./assets/product-05.jpg";
import games3 from "./assets/product-06.jpg";
import game4 from "./assets/product-08.jpg";
import games4 from "./assets/product-07.jpg";
import game5 from "./assets/product-09.jpg";
import games5 from "./assets/product-10.jpg";
import game6 from "./assets/product-11.jpg";
import games6 from "./assets/product-12.jpg";
import game7 from "./assets/product-13.jpg";
import games7 from "./assets/product-14.jpg";
import game8 from "./assets/product-15.jpg";
import games8 from "./assets/product-16.jpg";
import game9 from "./assets/product-17.jpg";
import games9 from "./assets/product-18.jpg";
import game10 from "./assets/product-19.jpg";
import games10 from "./assets/product-20.jpg";
import game11 from "./assets/product-21.jpg";
import games11 from "./assets/product-22.jpg";
import game12 from "./assets/product-23.jpg";
import games12 from "./assets/product-24.jpg";

import kids1 from "./assets/kid01.jpg";
import kids2 from "./assets/kid02.jpg";
import kids3 from "./assets/kid03.jpg";
import kids4 from "./assets/kid04.jpg";
import kids5 from "./assets/kid05.jpg";
import kids6 from "./assets/kid06.jpg";
import kids7 from "./assets/kid07.jpg";
import kids8 from "./assets/kid08.jpg";
import kids9 from "./assets/kid09.jpg";
import kids10 from "./assets/kid10.jpg";
import kids11 from "./assets/kid11.jpg";
import kids12 from "./assets/kid12.jpg";
import kids13 from "./assets/kid13.jpg";
import kids14 from "./assets/kid14.jpg";
import kids15 from "./assets/kid15.jpg";
import kids16 from "./assets/kid16.jpg";
import kids17 from "./assets/kid17.jpg";
import kids18 from "./assets/kid18.jpg";
import kids19 from "./assets/kid19.jpg";
import kids20 from "./assets/kid20.jpg";
import kids21 from "./assets/kid21.jpg";
import kids22 from "./assets/kid22.jpg";
import kids23 from "./assets/kid23.jpg";
import kids24 from "./assets/kid24.jpg";

import sport1 from "./assets/sports01.jpg";
import sports1 from "./assets/sports02.jpg";
import sport2 from "./assets/sports03.jpg";
import sports2 from "./assets/sports04.jpg";
import sport3 from "./assets/sports05.jpg";
import sports3 from "./assets/sports06.jpg";
import sport4 from "./assets/sports08.jpg";
import sports4 from "./assets/sports07.jpg";
import sport5 from "./assets/sports09.jpg";
import sports5 from "./assets/sports10.jpg";
import sport6 from "./assets/sports11.jpg";
import sports6 from "./assets/sports12.jpg";
import sport7 from "./assets/sports13.jpg";
import sports7 from "./assets/sports14.jpg";
import sport8 from "./assets/sports15.jpg";
import sports8 from "./assets/sports16.jpg";
import sport9 from "./assets/sports17.jpg";
import sports9 from "./assets/sports18.jpg";
import sport10 from "./assets/sports19.jpg";
import sports10 from "./assets/sports20.jpg";
import sport11 from "./assets/sports21.jpg";
import sports11 from "./assets/sports22.jpg";
import sport12 from "./assets/sports23.jpg";
import sports12 from "./assets/sports24.jpg";

import product1 from "./assets/product-detail-01.jpg";
import product2 from "./assets/product-detail-02.jpg";
import product3 from "./assets/product-detail-03.jpg";
import product4 from "./assets/product-detail-04.jpg";
import product5 from "./assets/product-detail-05.jpg";

import productKid01 from "./assets/kid01.jpg";
import productKid02 from "./assets/kid02.jpg";
import productKid03 from "./assets/kid03.jpg";
import productKid04 from "./assets/kid04.jpg";
import productKid05 from "./assets/kid05.jpg";
import productKid06 from "./assets/kid06.jpg";
import productKid07 from "./assets/kid09.jpg";
import productKid08 from "./assets/kid10.jpg";
import productKid09 from "./assets/kid17.jpg";
import productKid10 from "./assets/kid18.jpg";
import productKid11 from "./assets/kid19.jpg";
import productKid12 from "./assets/kid20.jpg";
import productKid13 from "./assets/kid15.jpg";
import productKid14 from "./assets/kid16.jpg";
import productKid15 from "./assets/kid21.jpg";
import productKid16 from "./assets/kid22.jpg";

export const PRODUCT = [
  {
    id: 1,
    image1: game1,
    image2: games1,
    title: "Call of Duty: Modern Warfare II",
    star: 4,
    price: "69.99",
    newprice: "79.99",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "homepage",
    productInfo: "",
    icon: "",
    productType: "cod",
  },
  {
    id: 2,
    image1: game2,
    image2: games2,
    title: "Ghost of Tsushima",
    star: 5,
    price: "54.79",
    newprice: "45.36",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 3,
    image1: game3,
    image2: games3,
    title: "Grand Theft Auto V",
    star: 4,
    price: "13.14",
    newprice: "23.00",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 4,
    image1: game4,
    image2: games4,
    title: "final fantasy 7: remake",
    star: 5,
    price: "17.00",
    newprice: "20.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 5,
    image1: game5,
    image2: games5,
    title: "Resident Evil Village",
    star: 4,
    price: "13.00",
    newprice: "15.01",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 6,
    image1: game6,
    image2: games6,
    title: "Assassin's Creed III: Remastered",
    star: 4,
    price: "13.00",
    newprice: "15.01",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 7,
    image1: game7,
    image2: games7,
    title: "The Witcher 3",
    star: 5,
    price: "16.85",
    newprice: "19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 8,
    image1: game8,
    image2: games8,
    title: "The Evil Within 2",
    star: 4,
    price: "16.85",
    newprice: "19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 9,
    image1: game9,
    image2: games9,
    title: "God of War Ragnarök",
    star: 4,
    price: "16.85",
    newprice: "19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 10,
    image1: game10,
    image2: games10,
    title: "Little Nightmares II",
    star: 5,
    price: "15.29",
    newprice: "22.20",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 11,
    image1: game11,
    image2: games11,
    title: "Far Cry 4",
    star: 4,
    price: "40.00",
    newprice: "60.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 12,
    image1: game12,
    image2: games12,
    title: "A Plague Tale: Innocence",
    star: 4,
    price: "22.49",
    newprice: "25.33",
    quick: "Quick View",
    addto: "Add To Cart",
    category: "arrival",
    news: "New",
    mainCategory: "recommend",
    type: "homepage",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },

  {
    id: 13,
    image1: kids1,
    image2: kids2,
    title: "Gran Turismo 7",
    star: 4,
    price: "22.49",
    newprice: " 25.33",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 14,
    image1: kids3,
    image2: kids4,
    title: "GRID Legends",
    star: 5,
    price: "69.99",
    newprice: "79.99",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 15,
    image1: kids5,
    image2: kids6,
    title: "Hot Wheels Unleashed",
    star: 4,
    price: "54.79",
    newprice: "45.36",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 16,
    image1: kids7,
    image2: kids8,
    title: "NBA 2K21",
    star: 5,
    price: "16.85",
    newprice: "19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 17,
    image1: kids9,
    image2: kids10,
    title: "Need for Speed Heat",
    star: 4,
    price: "13.14",
    newprice: "23.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 18,
    image1: kids11,
    image2: kids12,
    title: "Rocket League",
    star: 4,
    price: "17.00",
    newprice: "20.00",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 19,
    image1: kids13,
    image2: kids14,
    title: "EA SPORT FIFA 22",
    star: 5,
    price: "13.00",
    newprice: "15.01",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 20,
    image1: kids15,
    image2: kids16,
    title: "Need for Speed: Unbound",
    star: 4,
    price: "13.00",
    newprice: "15.01",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 21,
    image1: kids17,
    image2: kids18,
    title: "MLB The Show 21",
    star: 4,
    price: "16.85",
    newprice: "19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 22,
    image1: kids19,
    image2: kids20,
    title: "F1 22",
    star: 5,
    price: "16.85",
    newprice: "19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 23,
    image1: kids21,
    image2: kids22,
    title: "PGA Tour 2K21",
    star: 4,
    price: "15.20",
    newprice: "22.20",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 24,
    image1: kids23,
    image2: kids24,
    title: "Trials Rising",
    star: 4,
    price: "40.00",
    newprice: "60.00",
    quick: "Quick View",
    addto: "Add To Cart",
    category: "arrival",
    news: "New",
    mainCategory: "recommend",
    type: "",
    type2: "kid",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },

  {
    id: 25,
    image1: sport1,
    image2: sports1,
    title: "Gran Turismo 7",
    star: 4,
    price: "22.49",
    newprice: " 25.33",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 26,
    image1: sport2,
    image2: sports2,
    title: "GRID Legends",
    star: 5,
    price: "69.99",
    newprice: "79.99",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 27,
    image1: sport3,
    image2: sports3,
    title: "Hot Wheels Unleashed",
    star: 4,
    price: "54.79",
    newprice: "45.36",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 28,
    image1: sport4,
    image2: sports4,
    title: "NBA 2K21",
    star: 5,
    price: "16.85",
    newprice: "19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 29,
    image1: sport5,
    image2: sports5,
    title: "Need for Speed Heat",
    star: 4,
    price: "13.14",
    newprice: "23.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 30,
    image1: sport6,
    image2: sports6,
    title: "Rocket League",
    star: 4,
    price: "17.00",
    newprice: "20.00",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 31,
    image1: sport7,
    image2: sports7,
    title: "EA SPORT FIFA 22",
    star: 5,
    price: "13.00",
    newprice: "15.01",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 32,
    image1: sport8,
    image2: sports8,
    title: "Need for Speed: Unbound",
    star: 4,
    price: "13.00",
    newprice: "15.01",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 33,
    image1: sport9,
    image2: sports9,
    title: "MLB The Show 21",
    star: 4,
    price: "16.85",
    newprice: "19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 34,
    image1: sport10,
    image2: sports10,
    title: "F1 22",
    star: 5,
    price: "16.85",
    newprice: "19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 35,
    image1: sport11,
    image2: sports11,
    title: "PGA Tour 2K21",
    star: 4,
    price: "15.20",
    newprice: "22.20",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 36,
    image1: sport12,
    image2: sports12,
    title: "Trials Rising",
    star: 4,
    price: "40.00",
    newprice: "60.00",
    quick: "Quick View",
    addto: "Add To Cart",
    category: "arrival",
    news: "New",
    mainCategory: "recommend",
    type: "",
    type2: "",
    type3: "sport",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 38,
    image1: product1,
    title: "Genshin Impact",
    price: "69.99",
    newPrice: "79.99",
    type: "",
    type2: "",
    type3: "",
    type4: "product",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 38,
    image1: product2,
    title: "Genshin Impact",
    price: "69.99",
    newPrice: "79.99",
    type: "",
    type2: "",
    type3: "",
    type4: "product",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 39,
    image1: product3,
    title: "Genshin Impact",
    price: "69.99",
    newPrice: "79.99",
    type: "",
    type2: "",
    type3: "",
    type4: "product",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 40,
    image1: product4,
    title: "Genshin Impact",
    price: "69.99",
    newPrice: "79.99",
    type: "",
    type2: "",
    type3: "",
    type4: "product",
    type5: "",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 41,
    image1: product5,
    title: "Genshin Impact",
    price: "69.99",
    newPrice: "79.99",
    type: "",
    type2: "",
    type3: "",
    type4: "product",
    type5: "",
    type6: "",
    productInfo: "genshin",
    icon: "",
  },
  {
    id: 42,
    image1: productKid01,
    imgalt: productKid02,
    title: "Rec Room",
    price: "22.49",
    newprice: "25.33",
    news: "New",
    quick: "Quick View",
    type: "",
    type2: "",
    type3: "",
    type4: "",
    type5: "productKid",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 43,
    image1: productKid03,
    imgalt: productKid04,
    title: "Rec Room",
    price: "22.49",
    newprice: "25.33",
    news: "New",
    quick: "Quick View",
    type: "",
    type2: "",
    type3: "",
    type4: "",
    type5: "productKid",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 44,
    image1: productKid05,
    imgalt: productKid06,
    title: "Rec Room",
    price: "22.49",
    newprice: "25.33",
    nonew: "removeNew",
    quick: "Quick View",
    type: "",
    type2: "",
    type3: "",
    type4: "",
    type5: "productKid",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 45,
    image1: productKid07,
    imgalt: productKid08,
    title: "Rec Room",
    price: "22.49",
    newprice: "25.33",
    nonew: "removeNew",
    quick: "Quick View",
    type: "",
    type2: "",
    type3: "",
    type4: "",
    type5: "productKid",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 46,
    image1: productKid09,
    imgalt: productKid10,
    title: "Rec Room",
    price: "22.49",
    newprice: "25.33",
    nonew: "removeNew",
    quick: "Quick View",
    type: "",
    type2: "",
    type3: "",
    type4: "",
    type5: "productKid",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 47,
    image1: productKid11,
    imgalt: productKid12,
    title: "Rec Room",
    price: "22.49",
    newprice: "25.33",
    nonew: "removeNew",
    quick: "Quick View",
    type: "",
    type2: "",
    type3: "",
    type4: "",
    type5: "productKid",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 48,
    image1: productKid13,
    imgalt: productKid14,
    title: "Rec Room",
    price: "22.49",
    newprice: "25.33",
    nonew: "removeNew",
    quick: "Quick View",
    type: "",
    type2: "",
    type3: "",
    type4: "",
    type5: "productKid",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 49,
    image1: productKid15,
    imgalt: productKid16,
    title: "Rec Room",
    price: "22.49",
    newprice: "25.33",
    nonew: "removeNew",
    quick: "Quick View",
    type: "",
    type2: "",
    type3: "",
    type4: "",
    type5: "productKid",
    type6: "",
    productInfo: "",
    icon: "",
  },
  {
    id: 50,
    icon: "icon",
    type: "",
    type2: "",
    type3: "",
    type4: "",
    type5: "",
    type6: "",
    productInfo: "",
  },
];

export const FILTERIMAGE = [
  {
    id: 52,
    imgCard: game1,
  },
  {
    id: 53,
    imgCard: games1,
  },
  {
    id: 54,
    imgCard:
      "https://morax.hifive03.com/images/games/category_one/product-detail-03.jpg",
  },
  {
    id: 55,
    imgCard:
      "https://morax.hifive03.com/images/games/category_one/product-detail-04.jpg",
  },
  {
    id: 56,
    imgCard:
      "https://morax.hifive03.com/images/games/category_one/product-detail-05.jpg",
  },
];

export const SPORTIMG = [
  {
    id: 1,
    sportImg:
      "https://morax.hifive03.com/images/games/category_two/product-detail-01.jpg",
  },
  {
    id: 2,
    sportImg:
      "https://morax.hifive03.com/images/games/category_two/product-detail-02.jpg",
  },
  {
    id: 3,
    sportImg:
      "https://morax.hifive03.com/images/games/category_two/product-detail-03.jpg",
  },
  {
    id: 4,
    sportImg:
      "https://morax.hifive03.com/images/games/category_two/product-detail-04.jpg",
  },
  {
    id: 5,
    sportImg:
      "https://morax.hifive03.com/images/games/category_two/product-detail-05.jpg",
  },
];

export const HONKAI = [
  {
    id: 1,
    honkai: "https://wallpaperaccess.com/full/1580855.png",
  },
  {
    id: 2,
    honkai: "https://wallpaperaccess.com/full/1885645.png",
  },
  {
    id: 3,
    honkai: "https://wallpaperaccess.com/full/1580941.png",
  },
  {
    id: 4,
    honkai: "https://wallpaperaccess.com/full/1580971.jpg",
  },
  {
    id: 5,
    honkai: "https://wallpaperaccess.com/full/1885770.jpg",
  },
];
